import { useEffect, useState } from 'react';
import SitemapGenerator from '@/utils/sitemapGenerator';

const SitemapPage = () => {
    useEffect(() => {
        const generateAndDisplaySitemap = async () => {
            try {
                console.log('🚀 Generating dynamic sitemap...');
                const generator = new SitemapGenerator();
                const sitemapXml = await generator.generateSitemap();
                
                console.log('📄 Sitemap generated, replacing document...');
                
                // Устанавливаем правильный content-type через meta tag
                document.querySelector('html').setAttribute('lang', 'ru');
                
                // Полностью заменяем содержимое документа
                document.open();
                document.write(sitemapXml);
                document.close();
                
                // Устанавливаем content-type через meta (альтернативный способ)
                const meta = document.createElement('meta');
                meta.setAttribute('http-equiv', 'Content-Type');
                meta.setAttribute('content', 'application/xml; charset=utf-8');
                document.head.appendChild(meta);
                
            } catch (error) {
                console.error('❌ Error generating sitemap:', error);
                
                // Fallback - перенаправляем на статический sitemap
                window.location.replace('/sitemap.xml');
            }
        };

        generateAndDisplaySitemap();
    }, []);

    // Компонент не рендерит ничего, так как заменяет весь документ
    return null;
};

export default SitemapPage;
